export const DEFAULT_LANGUAGE = 'EN';
export const DEFAULT_THEME = '';
export const DEFAULT_TYPE = 'on-stage';
